module.exports = __webpack_public_path__ + "img/home_city_icon2_disabled.cc5f9d0.png";